import { TrackedShipmentState } from '@project44-models/shipment-entity';

export const isShipmentCompleted = (states: TrackedShipmentState[]) => {
  return states.some((state) => state.type === 'COMPLETED');
};
